import request from './request';

const productPricingTierService = {
  get(params) {
    return request.get('dashboard/admin/product-pricing-tiers', { params });
  },

  create(data) {
    return request.post('dashboard/admin/product-pricing-tiers', data, {
      headers: { 'Content-Type': 'application/json' },
    });
  },

  getByName(name, lang = 'en') {
    return request.get(
      `dashboard/admin/product-pricing-tiers/by-name/${encodeURIComponent(name)}?lang=${lang}`,
    );
  },

  update(name, data) {
    return request.put(
      `dashboard/admin/product-pricing-tiers/${encodeURIComponent(name)}`,
      data,
      {
        headers: { 'Content-Type': 'application/json' },
      },
    );
  },

  deleteById(id) {
    return request.delete(`dashboard/admin/product-pricing-tiers/delete/${id}`);
  },
};

export default productPricingTierService;
